/* tslint:disable */
/* eslint-disable */
/**
 * Validations API
 * Validator side of the quote validation requests
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RetarificationVariableValeurDto } from './RetarificationVariableValeurDto';
import {
    RetarificationVariableValeurDtoFromJSON,
    RetarificationVariableValeurDtoFromJSONTyped,
    RetarificationVariableValeurDtoToJSON,
    RetarificationVariableValeurDtoToJSONTyped,
} from './RetarificationVariableValeurDto';

/**
 * A tunnel guarantee selected by the validator, with its ceiling and deductible.
 * @export
 * @interface RetarificationGarantieSelectionDto
 */
export interface RetarificationGarantieSelectionDto {
    /**
     * 
     * @type {string}
     * @memberof RetarificationGarantieSelectionDto
     */
    garantieTunnelId: string;
    /**
     * Ceiling, keyed on the variable value of the tunnel guarantee.
     * @type {RetarificationVariableValeurDto}
     * @memberof RetarificationGarantieSelectionDto
     */
    plafond?: RetarificationVariableValeurDto | null;
    /**
     * Deductible, keyed on the variable value of the tunnel guarantee.
     * @type {RetarificationVariableValeurDto}
     * @memberof RetarificationGarantieSelectionDto
     */
    franchise?: RetarificationVariableValeurDto | null;
}

/**
 * Check if a given object implements the RetarificationGarantieSelectionDto interface.
 */
export function instanceOfRetarificationGarantieSelectionDto(value: object): value is RetarificationGarantieSelectionDto {
    if (!('garantieTunnelId' in value) || value['garantieTunnelId'] === undefined) return false;
    return true;
}

export function RetarificationGarantieSelectionDtoFromJSON(json: any): RetarificationGarantieSelectionDto {
    return RetarificationGarantieSelectionDtoFromJSONTyped(json, false);
}

export function RetarificationGarantieSelectionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RetarificationGarantieSelectionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'garantieTunnelId': json['garantieTunnelId'],
        'plafond': json['plafond'] == null ? undefined : RetarificationVariableValeurDtoFromJSON(json['plafond']),
        'franchise': json['franchise'] == null ? undefined : RetarificationVariableValeurDtoFromJSON(json['franchise']),
    };
}

export function RetarificationGarantieSelectionDtoToJSON(json: any): RetarificationGarantieSelectionDto {
    return RetarificationGarantieSelectionDtoToJSONTyped(json, false);
}

export function RetarificationGarantieSelectionDtoToJSONTyped(value?: RetarificationGarantieSelectionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'garantieTunnelId': value['garantieTunnelId'],
        'plafond': RetarificationVariableValeurDtoToJSON(value['plafond']),
        'franchise': RetarificationVariableValeurDtoToJSON(value['franchise']),
    };
}

